import React from 'react'
import DarkHeader from '../Components/DarkHeader'
import Section3 from '../Components/Sections/Section3'
import Footer from '../Components/Footer'

function Cookies() {
  return (
    <div>
        <DarkHeader />

        <section className="text-gray-600 body-font mt-5 p-12">
  <div className="container mx-auto flex px-5 py-24 md:flex-row flex-col">
    <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
	  
      <h4 className="title-font sm:text-6xl text-2xl mb-4  text-gray-900 font-bold leading-tight">Information Cookies
      </h4>
      <p className="mb-8 leading-relaxed text-sm">In order to track and attribute every sale that is done on our publisher's websites, digidp uses cookies that are installed on the user’s browsers. How these cookies work and what information they store for the different categories of users, is explained below. Category - Visitors Users that use and interact with the yieldlink platform administrative interface. This covers yieldlink Admins, Advertisers, Publishers and applicant Publishers. Cookies set are explicitly for providing the basic necessary functionalities to run the common business activities. Cookies: 2fa_enabled: stores information regarding whether a user is using the 2-factor authentication option. When the login screen loads, the information stored in this cookie allows the browser to remember whether to have enabled or disabled the little “enable two-factor-authentication” switch to facilitate the login process. Lifetime: 1 year. yieldlink_session: stores the unique ID that identifies the user browsing in the platform. Every time the user clicks a link into a different page in the platform, this is the unique identifier that allows the system to know that it is the same user, under the same session, who is “moving” across the platform. Lifetime: This cookie is deleted when the browser is closed. XSRF-TOKEN: this stores an additional unique ID that identifies the user browsing in the platform and that is less prompt to be mimicked by a malicious attacker. This additional identifier provides the necessary additional security layer that makes our systems secure and reliable. Lifetime: This cookie is deleted when the browser is closed. cookieconsent_status: stores the individual user preferences for cookie usage. Lifetime: 1 year. Category - Users No cookies from yieldlink are placed on the users that are visiting our publisher's websites, however, the 3rd party Networks with which yieldlink works might install cookies on the user’s browser when visiting one of our publisher's websites. <br />Cookies per Affiliate Network: Adcell Privacy Policy (in German): http://www.adcell.de/do-agb.html
Affiliate Future Privacy Policy: http://www.affiliatefuture.co.uk/faq/Privacy.asp
Affiliate Window Privacy Policy: http://www.affiliatewindow.com/documents/Privacy%20Policy.pdf
Affilinet Privacy Policy: http://www.affili.net/en/desktopdefault.aspx/tabid-50/rewritten-1/62_read-14/
Amazon Privacy Policy: http://www.amazon.com/gp/help/customer/display.html?nodeId=468496&ie=UTF8
Internet Based Ads info: http://www.amazon.com/b/?&node=5160028011 Opt-out of Personalized Ads: http://www.amazon.com/gp/dra/info Avangate Privacy Policy: http://www.avangate.com/online-payment-solutions/privacy.php AvantLink Privacy Policy: https://www.avantlink.com/privacy-policy
Belboon Privacy Policy: http://www.belboon.com/en/privacy.html
<br />
Clixgalore Privacy Policy: http://www.clixgalore.co.uk/privacy.asp
<br />
Commission Junction Privacy Policies: http://uk.cj.com/privacy.html & http://www.valueclick.com/privacy Opt-out here: http://www.valueclickmedia.com/about/privacy/opt-out eBay Partner Network Privacy Policy: https://partnernetwork.ebay.com/legal#privacy-policy
<br />
Impact Radius Privacy Policy: https://member.impactradius.com/content/data_privacy_policy.ihtml
iTunes Privacy Policy: https://www.apple.com/privacy/privacy-policy/
<br />
LinkShare Privacy Policy: http://www.linkshare.com/legal/privacy/
NetAffiliation Privacy Policy: http://en.netaffiliation.com/socpv/privacy-rights.html
Omnicom Group Privacy Policy: http://www.omnicommediagroup.com/disclaimer.html

 </p>
 
 
	  <br />
	   <h4 className="title-font sm:text-2xl text-2xl mb-4  text-gray-900 font-bold leading-tight">One Network Direct
      </h4>
	   <p className="mb-8 leading-relaxed">Privacy Policy: http://corporate.digitalriver.com/store/digriv/Corp/sectionName.company/subSectionName.corp<br />Policies/page.corpPolicies
Paid On Results Privacy Policy: http://www.paidonresults.com/privacy.html<br />
Pepperjam Privacy Policy: http://www.pepperjam.com/company/privacy-policy/<br />
Performance Horizon Privacy Policy: http://www.performancehorizon.com/docs/phg_privacy.pdf<br />
Public-Ideas Privacy Policy: http://en.publicideas.com/our-company/privacy-policies/<br />
ShareASale Privacy Policy: https://www.shareasale.com/agreement.cfm<br />
TradeDoubler Privacy Policy: http://www.tradedoubler.com/uk-en/legal/privacy.html<br />
Opt-out here: http://www.tradedoubler.com/uk-en/legal/targeting.html TradeTracker Privacy Policy: http://www.tradetracker.com/gb/privacy<br />
Webgains Privacy Policy: http://www.webgains.com/public/privacy/ Cookie table: http://www.webgains.com/public/privacy/webgains-cookies/ Zanox Privacy Policy: <br />http://www.zanox.com/en/about-zanox/policies/ The above list might not be up-to-date as new networks are added constantly. For a complete updated list you can always reach out to support@yieldlink.net and we will be happy to provide you with any information regarding cookies or privacy.<br />

</p>
   
    </div>
    <div className="lg:max-w-2xl lg:w-full md:w-1/2 w-5/6">
    <div className="lg:max-w-2xl w-full">
      <img className="object-cover object-center rounded-3xl lg:-ml-12" alt="hero" src="./img/girl.jpg" />
	  <div className="w-3/5  bg-white lg:-mt-72 lg:-ml-24" >
	      <img className="object-cover  h-96 rounded-2xl object-center border border-slate-200 " alt="hero" src="./img/small.jpg" />
	  </div>
    </div>
	  
	 <div className='mt-3'> 
	   <div className="w-12/12 ">
	  <img className="w-12/12" alt="hero" src="Main-slider_img.png" />
	  </div>
	  
     </div>
    </div>
	
  </div>
</section>

<Section3 />

<Footer />
    </div>
  )
}

export default Cookies